import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { MissionService } from '../../../services/mission.service';
import { DataColumn, WeeklyReportDto, DayDto } from '../../../models';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-weekly-reports',
  standalone: true,
  imports: [CommonModule, SharedModule, SvgIconComponent],
  templateUrl: './weekly-reports.component.html',
  styleUrl: './weekly-reports.component.scss',
})
export class WeeklyReportsComponent implements OnInit {
  weeklyReports: WeeklyReportDto[] = [];
  isLoading: boolean = false;
  expandedRows: Set<number> = new Set();
  totalItems: number = 0;

  customColumns: DataColumn[] = [
    {
      header: 'Nom',
      fieldName: 'candidatName',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Prénom',
      fieldName: 'candidatLastName',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Type de Poste',
      fieldName: 'typePoste',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Service',
      fieldName: 'serviceAffectation',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Semaine',
      fieldName: 'weekPeriod',
      dataType: 'string',
      col: 'col',
    },
  ];

  constructor(private missionService: MissionService) { }

  ngOnInit(): void {
    this.loadWeeklyReports();
  }

  loadWeeklyReports(): void {
    this.isLoading = true;
    this.missionService.getWeeklyReports().subscribe({
      next: (reports: WeeklyReportDto[]) => {
        this.weeklyReports = reports;
        this.totalItems = reports.length;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading weekly reports:', err);
        this.isLoading = false;
      },
    });
  }

  toggleRowExpansion(index: number): void {
    if (this.expandedRows.has(index)) {
      this.expandedRows.delete(index);
    } else {
      this.expandedRows.add(index);
    }
  }

  isRowExpanded(index: number): boolean {
    return this.expandedRows.has(index);
  }

  getStatusLabel(status: string): string {
    const statusMap: { [key: string]: string } = {
      'DRAFT': 'Non finalisée',
      'WAITING_AG_VALIDATION': 'Finalisée',
    };
    return statusMap[status] || status;
  }

  handleRowClick(evt: any, index: number): void {
    this.toggleRowExpansion(index);
  }
}
